<script lang="ts">
	import { t, type Language } from '$lib/i18n';

	import traftec from '$lib/assets/clients/traftec.png';
	import oceanize from '$lib/assets/clients/oceanize.png';
	import aquarama from '$lib/assets/clients/aquarama.png';
	import marnarbruk from '$lib/assets/clients/marnar_bruk.png';
	import enoktotal from '$lib/assets/clients/enoktotal.png';
	import svv from '$lib/assets/clients/svv.svg';
	import nyeveier from '$lib/assets/clients/nyeveier.svg';
	import hellefoss from '$lib/assets/clients/hellefoss.png';
	import vafos from '$lib/assets/clients/vafos.gif';
	import rygene from '$lib/assets/clients/rygene.png';

	interface Props {
		lang: Language;
	}

	let { lang }: Props = $props();
	let tr = $derived(t(lang));

	// Other clients (not Rygene - that's featured)
	const clients = [
		{ name: 'Traftec', logo: traftec },
		{ name: 'Statens vegvesen', logo: svv },
		{ name: 'Nye Veier', logo: nyeveier },
		{ name: 'Marnar Bruk', logo: marnarbruk, scale: 1.5 },
		{ name: 'Hellefoss', logo: hellefoss },
		{ name: 'Vafos', logo: vafos },
		{ name: 'Aquarama', logo: aquarama },
		{ name: 'Oceanize', logo: oceanize },
		{ name: 'Enok Total', logo: enoktotal }
	];
</script>

<section class="py-16 md:py-24 relative overflow-hidden">
	<div class="max-w-7xl mx-auto px-6">
		<div class="grid md:grid-cols-2 gap-12 md:gap-16 items-center">
			<!-- Featured testimonial -->
			<div class="order-2 md:order-1">
				<div class="relative">
					<!-- Accent line -->
					<div
						class="absolute -left-4 top-0 bottom-0 w-1 bg-gradient-to-b from-ameta-green to-ameta-green/0 rounded-full"
					></div>

					<blockquote class="text-xl md:text-2xl text-slate-200 font-medium leading-relaxed mb-6">
						"{tr('testimonial_quote')}"
					</blockquote>

					<div class="flex items-center gap-4">
						<img
							src={rygene}
							alt="Rygene-Smith & Thommesen"
							class="h-8 w-auto brightness-0 invert opacity-90 client-logo"
						/>
						<div class="h-8 w-px bg-slate-700"></div>
						<div>
							<p class="text-slate-300 font-medium text-sm">{tr('testimonial_author')}</p>
							<p class="text-slate-400 text-sm">{tr('testimonial_role')}</p>
						</div>
					</div>

					<a
						href="/{lang}/case-studies/rygene"
						class="inline-flex items-center gap-2 mt-6 text-ameta-green hover:text-ameta-green/80 transition-colors text-sm font-medium group"
					>
						{tr('testimonial_read_case_study')}
						<svg
							class="w-4 h-4 group-hover:translate-x-1 transition-transform"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
							aria-hidden="true"
						>
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M17 8l4 4m0 0l-4 4m4-4H3"
							/>
						</svg>
					</a>
				</div>
			</div>

			<!-- Other clients -->
			<div class="order-1 md:order-2">
				<p class="text-sm text-slate-400 uppercase tracking-wider mb-6">{tr('clients_title')}</p>

				<div class="grid grid-cols-3 gap-6 md:gap-8">
					{#each clients as client}
						<div class="flex items-center justify-center h-10 md:h-12">
							<img
								src={client.logo}
								alt={client.name}
								class="max-h-full max-w-[80px] md:max-w-[100px] w-auto object-contain opacity-60 hover:opacity-100 transition-opacity duration-300 brightness-0 invert client-logo"
								style={client.scale ? `transform: scale(${client.scale})` : ''}
							/>
						</div>
					{/each}
				</div>
			</div>
		</div>
	</div>
</section>
